export const UPDATE_MASTER = "UPDATE_MASTER";
export const CLEAR_MASTER = "CLEAR_MASTER";
export const ADD_ORG = "ADD_ORG";
export const CLEAR_ORG = "CLEAR_ORG";
export const CLEAR_HEADER = "CLEAR_HEADER";
